// export const BASE_URL = "http://ecommerce.tp/api";
export const BASE_URL = process.env.REACT_APP_BASE_URL;
